import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Foundations'

export const ManualInputTextStyled = styled.div({
  color: colors.neutral[600],
  margin: '0.8rem 0',
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  ...font.size.md,

  '> [role="button"]': {
    color: colors.studio[500],
  },
})
